"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BestowLifeAbilityHandler = exports.BestowLifeActorAbilityFactory = exports.BestowLifeAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Registries_1 = require("../../core/state/Registries");
const Damage_1 = require("../../core/Damage");
const ts_essentials_1 = require("ts-essentials");
const core_1 = require("../../core/vfx/core");
const enums_1 = require("../../core/enums");
const LocationSelector_1 = require("../../core/vfx/LocationSelector");
class BestowLifeAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.BestowLife;
        this.__typeName = "BestowLife";
    }
}
exports.BestowLifeAbilityArgs = BestowLifeAbilityArgs;
let BestowLifeActorAbilityFactory = class BestowLifeActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("BestowLife", "OneAllies", 0);
    }
};
BestowLifeActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("BestowLife")
], BestowLifeActorAbilityFactory);
exports.BestowLifeActorAbilityFactory = BestowLifeActorAbilityFactory;
let BestowLifeAbilityHandler = class BestowLifeAbilityHandler {
    init(sequence, container, actorId) { }
    activate(sequence, container, ability) {
        const [selectedAlly] = ability.args.target.actorIds;
        (0, ts_essentials_1.assert)(selectedAlly !== ability.invokerId, `400|CannotBestowLifeOnSelf`);
        const amount = container.getPercentOfBaseHealth(ability.invokerId, 5);
        const healthBefore = container.getAttributeScore(ability.invokerId, enums_1.AttributeType.Health);
        (0, ts_essentials_1.assert)(amount < healthBefore, "500|CannotKillSelfWithBestowLife");
        container.applyAbilityAnimation({
            sequence,
            abilityKey: ability.args.__typeName,
            fallback: "casting",
            animatedId: ability.invokerId,
            onAnimated(sequence) {
                const transferSequence = sequence
                    .pushSequence("sequential")
                    .push(new core_1.InstantVfxStepArgs(new LocationSelector_1.ActorVfxLocationSelector(ability.invokerId, "chest"), "PulsingBlood"));
                container.applyExactDamage({
                    sequence: transferSequence.pushSequence("sequential"),
                    attackerId: ability.invokerId,
                    targetId: ability.invokerId,
                    damage: new Damage_1.Damage(enums_1.DamageType.Death, amount)
                });
                container.applyHealing({
                    sequence: transferSequence.pushSequence("sequential"),
                    healerId: ability.invokerId,
                    targetId: selectedAlly,
                    amount: amount * 2,
                    onApplied: sequence => sequence.push(new core_1.InstantVfxStepArgs(new LocationSelector_1.ActorVfxLocationSelector(selectedAlly, "feet"), "FallingBloodMissle"))
                });
            }
        });
    }
};
BestowLifeAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.BestowLife)
], BestowLifeAbilityHandler);
exports.BestowLifeAbilityHandler = BestowLifeAbilityHandler;
